/**
 * Open Rebuy SmartCart from header [data-cart-link] with retries.
 * Live header used window.Rebuy.SmartCart.show(); Rebuy often boots after click.
 */
(function () {
  function openSmartCart() {
    var rebuy = window.Rebuy;
    if (!rebuy) return false;

    if (rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') {
      rebuy.SmartCart.show();
      return true;
    }

    if (rebuy.smartCart && typeof rebuy.smartCart.show === 'function') {
      rebuy.smartCart.show();
      return true;
    }

    // Event fallbacks used by Rebuy widgets
    document.dispatchEvent(new CustomEvent('rebuy:smartcart.show', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('rebuy:cart.show', { bubbles: true }));
    return !!(rebuy.SmartCart || rebuy.smartCart);
  }

  function openWithRetry() {
    if (openSmartCart()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (openSmartCart() || tries >= 20) clearInterval(timer);
    }, 150);
  }

  function bind() {
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      if (el.dataset.aRebuyBound === '1') return;
      el.dataset.aRebuyBound = '1';
      el.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openWithRetry();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Rebuy ready hooks
  document.addEventListener('rebuy:smartcart.ready', function () {
    bind();
  });
  document.addEventListener('rebuy:cart.ready', function () {
    bind();
  });
})();
